import axios from 'axios'


const state = {
    colors: [
        {"id":"1","dataColor":"rgb(255, 255, 255)","style":"background-color: #FFFFFF"},
        {"id":"2","dataColor":"rgb(46, 41, 37)","style":"background-color: #2E2925"},
        {"id":"3","dataColor":"rgb(85, 87, 89)","style":"background-color: #555759"},
        {"id":"4","dataColor":"rgb(153, 153, 154)","style":"background-color: #99999A"},
        {"id":"5","dataColor":"rgb(81, 54, 40)","style":"background-color: #513628"},
        {"id":"6","dataColor":"rgb(20, 71, 51)","style":"background-color: #144733"},
        {"id":"7","dataColor":"rgb(0, 117, 73)","style":"background-color: #007549"},
        {"id":"8","dataColor":"rgb(119, 188, 31)","style":"background-color: #77BC1F"},
        {"id":"9","dataColor":"rgb(13, 82, 87)","style":"background-color: #0D5257"},
        {"id":"10","dataColor":"rgb(0, 137, 150)","style":"background-color: #008996"},
        {"id":"11","dataColor":"rgb(34, 41, 68)","style":"background-color: #222944"},
        {"id":"12","dataColor":"rgb(21, 76, 153)","style":"background-color: #154C99"},
        {"id":"13","dataColor":"rgb(0, 155, 222)","style":"background-color: #009BDE"},
        {"id":"14","dataColor":"rgb(148, 192, 233)","style":"background-color: #94C0E9"},
        {"id":"15","dataColor":"rgb(82, 10, 118)","style":"background-color: #520A76"},
        {"id":"16","dataColor":"rgb(229, 26, 146)","style":"background-color: #E51A92"},
        {"id":"17","dataColor":"rgb(254, 160, 201)","style":"background-color: #FEA0C9"},
        {"id":"18","dataColor":"rgb(115, 36, 61)","style":"background-color: #73243D"},
        {"id":"19","dataColor":"rgb(172, 0, 51)","style":"background-color: #AC0033"},
        {"id":"20","dataColor":"rgb(235, 0, 41)","style":"background-color: #EB0029"},
        {"id":"21","dataColor":"rgb(241, 134, 38)","style":"background-color: #F18626"},
        {"id":"22","dataColor":"rgb(255, 184, 25)","style":"background-color: #FFB819"},
        {"id":"23","dataColor":"rgb(254, 221, 61)","style":"background-color: #FEDD3D"},
        {"id":"24","dataColor":"rgb(209, 190, 126)","style":"background-color: #D1BE7E"},
        {"id":"25","dataColor":"rgb(247, 234, 218)","style":"background-color: #F7EADA"},
    ],
    jacketDesign: [
        { id: 1 , src: 'normal_thumb.png','name': 'common'},
        { id: 2 , src: 'hoodie_thumb.png', 'name': 'hoodie'}
    ],
    fonts: [
        {'value':"'Athletic', sans-serif",id:1,'name':"Athletic"},
        {'value':"'Euphemia UCAS', sans-serif",id:2,'name':"Euphemia UCAS"},
        {'value':"'Old English Regular', sans-serif",id:3, 'name':"Old English Regular"},
        {'value':"'Script', sans-serif",id:4, 'name':"Script"},
        {'value':"'Western', sans-serif",id:5, 'name':"Western"}
    ],
    colorType:[
        {id: 1, value: 'basecolor', name: 'One Color'},
        {id: 2, value: 'outlinecolor', name: 'Two Colors'},
    ],
    styles: ["common","hoodie"],
    sides: ["front","right","back","left"],
    leftChest: [
        { id:"leftChest_none", name: "leftChest", value: 'none' , lavel: 'None'},
        { id:"leftChest_letters", name: "leftChest", value: 'letters' , lavel: 'Add Numbers & Letters'},
        { id:"leftChest_logos", name: "leftChest", value: 'logos' , lavel: 'Add Logos'},
        { id:"leftChest_years", name: "leftChest", value: 'years' , lavel: 'Add Years'},
    ],
    rightChest: [
        { id:"rightChest_none", name: "rightChest", value: 'none' , lavel: 'None'},
        { id:"rightChest_letters", name: "rightChest", value: 'letters' , lavel: 'Add Numbers & Letters'},
        { id:"rightChest_name", name: "rightChest", value: 'name' , lavel: 'Add Name'},
        { id:"rightChest_logos", name: "rightChest", value: 'logos' , lavel: 'Add Logos'},
        { id:"rightChest_years", name: "rightChest", value: 'years' , lavel: 'Add Years'},
    ],
    leftSleeve: [
        { id:"leftSleeve_none", name: "leftSleeve", value: 'none' , lavel: 'None'},
        { id:"leftSleeve_letters", name: "leftSleeve", value: 'letters' , lavel: 'Add Numbers & Letters'},
        { id:"leftSleeve_logos", name: "leftSleeve", value: 'logos' , lavel: 'Add Logos'},
        { id:"leftSleeve_years", name: "leftSleeve", value: 'years' , lavel: 'Add Years'},
    ],
    rightSleeve: [
        { id:"rightSleeve_none", name: "rightSleeve", value: 'none' , lavel: 'None'},
        { id:"rightSleeve_letters", name: "rightSleeve", value: 'letters' , lavel: 'Add Numbers & Letters'},
        { id:"rightSleeve_logos", name: "rightSleeve", value: 'logos' , lavel: 'Add Logos'},
        { id:"rightSleeve_years", name: "rightSleeve", value: 'years' , lavel: 'Add Years'},
    ],
    back: [
        { id:"back_none", name: "backShoulder", value: 'none' , lavel: 'None'},
        { id:"backShoulder_letters", name: "backShoulder", value: 'shoulderLetters' , lavel: 'Add Shoulder Text'},
        { id:"backShoulder_logos", name: "backShoulder", value: 'shoulderLogos' , lavel: 'Add Back Logos'},
        { id:"backShoulderWaist_letters", name: "backShoulder", value: 'waistLetters' , lavel: 'Add Waist Text'},
    ],
    sizes: [
        {id: 1, value: 'XXSMALL'},
        {id: 2, value: 'XSMALL'},
        {id: 3, value: 'SMALL'},
        {id: 4, value: 'SMALL TALL'},
        {id: 5, value: 'SSMALL XTALL'},
        {id: 6, value: 'MEDIUM'},
        {id: 7, value: 'MEDIUM TALL'},
        {id: 8, value: 'MEDIUM XTALL'},
        {id: 9, value: 'LARGE'},
        {id: 10, value: 'LARGE TALL'},
        {id: 11, value: 'LARGE XTALL'},
        {id: 12, value: 'XLARGE'},
        {id: 13, value: 'XLARGE TALL'},
        {id: 14, value: 'XLARGE XTALL'},
        {id: 15, value: '2XLARGE'},
        {id: 16, value: '2XLARGE TALL'},
        {id: 17, value: '2XLARGE XTALL'},
        {id: 18, value: '3XLARGE'},
        {id: 19, value: '3XLARGE TALL'},
        {id: 20, value: '3XLARGE XTALL'},
        {id: 21, value: '4XLARGE'},
        {id: 22, value: '4XLARGE TALL'},
        {id: 23, value: '4XLARGE XTALL'},
        {id: 24, value: '5XLARGE'},
        {id: 25, value: '5XLARGE TALL'},
        {id: 26, value: '5XLARGE XTALL'},
        {id: 27, value: '5XLARGE'},
        {id: 28, value: '5XLARGE TALL'},
        {id: 29, value: '5XLARGE XTALL'},
        {id: 30, value: '6XLARGE'},
        {id: 31, value: '6XLARGE TALL'},
        {id: 32, value: '6XLARGE XTALL'},
    ],
    logos: '',
    curentJacket: 'common',
    jacketSelectd: false,
    common_jacket:true,
    common_front: true,
    common_back: false,
    common_left: false,
    common_right: false,
    hoodie_jacket:false,
    hoodie_front: false,
    hoodie_back: false,
    hoodie_left: false,
    hoodie_right: false,   

    jacket_error: false,
    jacketErrorMessage: '', 

    jacket_selected: false, 
    jacket_div: true,

    body_selected: false,
    body_div: false,
    body_id: '',
    body_color: 'transparent',
    
    sleeve_selected: false,
    sleeve_div: false,
    sleeve_id: '',
    sleeve_color: 'transparent',

    pocket_selected: false,
    pocket_div: false,
    pocket_id: '',
    pocket_color: 'transparent',
    
    button_selected: false,
    button_div: false,
    button_id: '',
    button_color: 'transparent',

    knit_selected: false,
    knit_div: false,
    solid_div: false,
    solid_selected: false,
    solid_id: '',
    solid_color: 'transparent',
    single_div: false,
    single_selected: false,
    single_stripe_id: '',
    single_stripe_color: 'transparent',
    double_div: false,
    double_selected: false,
    double_stripe_id: '',
    double_stripe_color: 'transparent',
    feather_selected: false,
    feather_div: false,
    feather_stripe_id: '',
    feather_stripe_color: 'transparent',

    leftChest_selected: false,
    leftChest_div: false,
    leftChest_id: '',
    leftChest_letters: '',
    leftChest_letters_fontfamily: '',
    leftChest_letters_fontfamily_id: '',
    leftChest_letters_color: 'transparent',
    leftChest_letters_colors_id: '',
    leftChest_basecolor_div: false,
    leftChest_outlinecolor_div: false,
    leftChest_basecolor: 'transparent',
    leftChest_outlinecolor: 'transparent',
    leftChest_basecolor_id: '',
    leftChest_outlinecolor_id: '',
    leftChest_logos: '',
    leftChest_years: '',
    leftChest_years_id: '',
    leftChest_years_color_div: false,
    leftChest_years_basecolor_id: '',
    leftChest_years_basecolor: 'transparent',
    leftChest_years_outlinecolor: 'transparent',
    leftChest_years_outlinecolor_id: '',

    rightChest_selected: false,
    rightChest_div: false,
    rightChest_id: '',
    rightChest_letters: '',
    rightChest_letters_fontfamily: '',
    rightChest_letters_fontfamily_id: '',

    rightChest_name: '',
    rightChest_name_fontfamily: '',
    rightChest_name_fontfamily_id: '',
    rightChest_name_basecolor: 'transparent',
    rightChest_name_basecolor_id:'',
    rightChest_letters_color: 'transparent',
    rightChest_letters_colors_id: '',
    rightChest_basecolor_div: false,
    rightChest_outlinecolor_div: false,
    rightChest_basecolor: 'transparent',
    rightChest_outlinecolor: 'transparent',
    rightChest_basecolor_id: '',
    rightChest_outlinecolor_id: '',
    rightChest_logos: '',
    rightChest_years: '',
    rightChest_years_id: '',
    rightChest_years_color_div: false,
    rightChest_years_basecolor_id: '',
    rightChest_years_basecolor: 'transparent',
    rightChest_years_outlinecolor: 'transparent',
    rightChest_years_outlinecolor_id: '',

    rightSleeve_selected: false,
    rightSleeve_div: false,
    rightSleeve_id: '',
    rightSleeve_letters: '',
    rightSleeve_letters_fontfamily: '',
    rightSleeve_letters_fontfamily_id: '',
    rightSleeve_letters_color: 'transparent',
    rightSleeve_letters_colors_id: '',
    rightSleeve_basecolor_div: false,
    rightSleeve_outlinecolor_div: false,
    rightSleeve_basecolor: 'transparent',
    rightSleeve_outlinecolor: 'transparent',
    rightSleeve_basecolor_id: '',
    rightSleeve_outlinecolor_id: '',
    rightSleeve_logos: '',
    rightSleeve_years: '',
    rightSleeve_years_id: '',
    rightSleeve_years_color_div: false,
    rightSleeve_years_basecolor_id: '',
    rightSleeve_years_basecolor: 'transparent',
    rightSleeve_years_outlinecolor: 'transparent',
    rightSleeve_years_outlinecolor_id: '',

    leftSleeve_selected: false,
    leftSleeve_div: false,
    leftSleeve_id: '',
    leftSleeve_letters: '',
    leftSleeve_letters_fontfamily: '',
    leftSleeve_letters_fontfamily_id: '',
    leftSleeve_letters_color: 'transparent',
    leftSleeve_letters_colors_id: '',
    leftSleeve_basecolor_div: false,
    leftSleeve_outlinecolor_div: false,
    leftSleeve_basecolor: 'transparent',
    leftSleeve_outlinecolor: 'transparent',
    leftSleeve_basecolor_id: '',
    leftSleeve_outlinecolor_id: '',
    leftSleeve_logos: '',
    leftSleeve_years: '',
    leftSleeve_years_id: '',
    leftSleeve_years_color_div: false,
    leftSleeve_years_basecolor_id: '',
    leftSleeve_years_basecolor: 'transparent',
    leftSleeve_years_outlinecolor: 'transparent',
    leftSleeve_years_outlinecolor_id: '',

    back_selected: false,
    back_div: false,
    backShoulder_id: '',  
    backShoulder_letters: '',
    backShoulder_letters_fontfamily:'',
    backShoulder_letters_fontfamily_id:'',
    backShoulder_letters_colors_id:'',
    backShoulder_letters_basecolor_div: false,
    backShoulder_letters_basecolor:'transparent',
    backShoulder_letters_basecolor_id:'',
    backShoulder_letters_outlinecolor_div: false,
    backShoulder_letters_outlinecolor:'transparent',
    backShoulder_letters_outlinecolor_id:'',
    backShoulder_logos:'',
    backShoulderWaist_letters:'',
    backShoulderWaist_letters_fontfamily:'',
    backShoulderWaist_letters_fontfamily_id:'',
    backShoulderWaist_letters_colors_id:'',
    backShoulderWaist_letters_basecolor_div: false,
    backShoulderWaist_letters_basecolor: 'transparent',
    backShoulderWaist_letters_basecolor_id: '',
    backShoulderWaist_letters_outlinecolor_div: false,
    backShoulderWaist_letters_outlinecolor: 'transparent',
    backShoulderWaist_letters_outlinecolor_id:'',

    user_height_id: '',
    user_weight_id: '',
    user_size_id: '',
    place_div: false,
    place_id: '',
    jacketFront: null,
    jacketBack: null,
    jacketLeft: null,
    jacketRight: null

};
export const setjacket = (state,payload) => {
    let style = payload.style
    let jacketType = payload.jacketType
    let set = payload.set
    let sides = payload.sides
    jacketType.forEach(value => {
        if(value === style){
            sides.forEach(values => {
                values === set ? state[value+'_'+set] = true :  state[value+'_'+values] = false
            })
        }else{
            sides.forEach(values => {
                state[value+'_'+values] = false
            })
        }
    })
};
const mutations = {
    set_jacket(state, payload){
        state.curentJacket = payload.style
        state.jacket_selected = true
        state.jacketSelectd = true
        state.jacket_div = false
        state.jacket_error = false
        state.body_div = true
        state.jacketErrorMessage = "";
        let style = payload.style
        let jacketType = payload.jacketType
        jacketType.forEach(value => {
            value === style ? state[style+'_jacket'] = true : state[value+'_jacket'] = false
        })
    },
    set_front(state, payload){
        setjacket(state, payload)
    },
    set_back(state, payload){
        setjacket(state, payload)
    },
    set_left(state, payload){
        setjacket(state, payload)
    },
    set_right(state, payload){
        setjacket(state, payload)
    },
    openMenu(state, payload){
        let menu = payload.menu
        let menuList = payload.menuList
        menuList.forEach( value => {
            value === menu ? state[menu+'_div'] = true : state[value+'_div'] = false
        });
        // if(menu === 'size'){
        //     state[menu+'_id'] = menu
        // }
    },
    setError(state, payload){
        state.jacket_error = true;
        state.jacketErrorMessage = payload;
    },
    setDeisgnSelected(state, payload){
        state[payload+'_selected'] = true
    },
    openTrim(state, payload){
        state.knit_selected = true
        if(payload == 'solid'){
            state.solid_div = true;
            state.solid_selected = true;
            state.single_div = false;
            state.single_selected = false;
            state.double_div = false;
            state.double_selected = false;
            state.feather_selected = false;
            state.feather_div = false;
        }
        if(payload == 'single_stripe'){
            state.solid_div = true;
            state.solid_selected = false;
            state.single_div = true;
            state.single_selected = true;
            state.feather_selected = false;
            state.feather_div = false;
            state.double_div = false;
            state.double_selected = false;
        }
        if(payload == 'double_stripe'){
            state.solid_div = true;
            state.solid_selected = false;
            state.single_div = false;
            state.single_selected = false;
            state.feather_selected = false;
            state.feather_div = false;
            state.double_div = true;
            state.double_selected = true;
        }
        if(payload == 'feather_stripe'){
            state.solid_div = true;
            state.solid_selected = false;
            state.single_div = false;
            state.single_selected = false;
            state.double_div = true;
            state.double_selected = false;
            state.feather_selected = true;
            state.feather_div = true;

        }
    },
    set_color(state, payload){
        state[payload.type+'_id'] = payload.type+'_'+payload.id
        state[payload.type+'_color'] = payload.color
    },
    setCustomMenuId(state, payload){
        state[payload.name+'_id'] = payload.id
        state[payload.name+'_selected'] = true
    },
    setLeftChestLetter(state, payload){
        if(state.rightChest_id === 'rightChest_name' && payload.type === 'rightChest'){
            state['rightChest_name'] = payload.content
        }else{
            state[payload.type+'_letters'] = payload.content
        }
        
    },
    setLeftChestLetterFontFamily(state, payload){
        if(state.rightChest_id === 'rightChest_name' && payload.type === 'rightChest'){
            state[payload.type+'_letters_fontfamily'] = payload.fontFamily
            state[payload.type+'_name_letters_fontfamily_id'] = payload.type+'name_letters_fontfamily_'+payload.fontFamilyId
        }else{
            state[payload.type+'_letters_fontfamily'] = payload.fontFamily
            state[payload.type+'_letters_fontfamily_id'] = payload.type+'_letters_fontfamily_'+payload.fontFamilyId    
        }
    },
    setLeftChestLogo(state, payload){
        state[payload.type+'_logos'] = payload.logo
    },
    setCustomizeDiv(state, payload){
        let ids = payload.ids;
        let menu = payload.value
        let opt_id = payload.opt_id
        if(state.rightChest_id === 'rightChest_name'){
            state[payload.type+'_colors_id'] = payload.type+'_letters_colors_'+opt_id;
        }else{
            state[payload.type+'_letters_colors_id'] = payload.type+'_letters_colors_'+opt_id;
        }
        if((state.backShoulder_id === 'backShoulder_letters' || state.backShoulder_id === 'backShoulderWaist_letters') ){       
            if(menu === 'outlinecolor'){
                state[payload.type+'_letters_basecolor_div'] = true 
                state[payload.type+'_letters_outlinecolor_div'] = true
            }else{
                state[payload.type+'_letters_basecolor_div'] = true 
                state[payload.type+'_letters_outlinecolor_div'] = false
            }  
        }else{
            ids.forEach( value => {
                if(menu === 'outlinecolor'){
                    value === menu ? state[payload.type+'_'+menu+'_div'] = true : state[payload.type+'_'+value+'_div'] = true
                }else{
                    value === menu ? state[payload.type+'_'+menu+'_div'] = true : state[payload.type+'_'+value+'_div'] = false
                }  
            })
        }
        
    },
    fillCustomizeColor(state, payload){
        state[payload.type+'_'+payload.color_type+'_id'] = payload.type+'_'+payload.color_type+'_'+payload.id
        state[payload.type+'_'+payload.color_type] = payload.color
    },
    setYeareDiv(state, payload){
        
        state[payload.type+'_years_color_div'] = true
        state[payload.type+'_years'] = payload.value
        state[payload.type+'_years_id'] = payload.type+'_years_'+payload.year_id
    },
    fillYearColor(state, payload){
        state[payload.type+'_'+payload.color_type+'_id'] = payload.type+'_'+payload.color_type+'_'+payload.id
        state[payload.type+'_'+payload.color_type] = payload.color
    },
    setJacket(state, payload){
        
        state.jacketFront  = payload.jacketFront
        state.jacketBack = payload.jacketBack
        state.jacketLeft = payload.jacketLeft
        state.jacketRight  = payload.jacketRight
        
    }
};
const actions = {
    displayPreview({commit}, payload) {
        return new Promise( (resolve) => {
        let API_URL = 'http://supportsoft.in/jacket/api';
            let url = API_URL+'/order-details';
            axios.post(url, {user_key : payload}).then( res => {
                let response = res.data.data;
                let jacket = { jacketFront: response.jacketFront, jacketBack: response.jacketBack,
                    jacketLeft: response.jacketLeft, jacketRight: response.jacketRight};
                    commit('setJacket', jacket);
                    resolve(jacket);
            });
        });
    },
    placeOrder({ commit}, payload){
        return new Promise( (resolve) => {
            let API_URL = 'http://supportsoft.in/jacket/api';
            let url = API_URL+'/add-order';
            axios.post(url, payload).then( response => {
                let jacket = { jacketFront: payload.jacketFront, jacketBack: payload.jacketBack,
                    jacketLeft: payload.jacketLeft, jacketRight: payload.jacketRight};
                commit('setJacket', jacket);
                resolve(payload.user_key);
            });
            
        })
    },

    fillYearColor({commit}, payload){
        return new Promise( resolve => {
            commit('fillYearColor', payload)
            resolve()
        })
    },
    setYeareDiv({commit}, payload){
       return new Promise( resolve => {
            commit('setYeareDiv', payload)
            resolve()
       }) 
    },
    fillCustomizeColor({commit}, payload){
        return new Promise(resolve => {
            commit('fillCustomizeColor', payload)
            resolve()
        })
        
    },
    setCustomizeDiv({commit}, payload){
        commit('setCustomizeDiv', payload);
    },
    setLeftChestLogo({commit}, payload){
        return new Promise( resolve => {
            commit('setLeftChestLogo', payload)
            resolve()
        })
    },
    setLeftChestLetterFontFamily({commit}, payload) {
        return new Promise( resolve => {
            commit('setLeftChestLetterFontFamily', payload)
            resolve()
        });
    },
    setLeftChestLetter({commit}, payload){
        return new Promise( (resolve) => {
            commit('setLeftChestLetter', payload)
            resolve();
        })
    },
    openCustomDiv({commit}, payload){
        commit('setCustomMenuId', payload)
    },
    setColorId({commit}, payload){
        commit('set_color', payload)
    },
    openTrim({commit}, payload){
        commit('openTrim', payload)
    },
    designSelected({commit}, payload){
        commit('setDeisgnSelected', payload)
    },
    errorMessage({commit}, payload){
        commit('setError', payload)
    },
    openMenu({commit}, payload){
        commit('openMenu', payload)
    },
    set_jacket({commit}, payload){
        commit('set_jacket', payload)
    },
    set_front({commit}, payload){
        commit('set_front', payload)
    },
    set_back({commit}, payload){
        commit('set_back', payload)
    },
    set_left({commit}, payload){
        commit('set_left', payload)
    },
    set_right({commit}, payload){
        commit('set_right', payload)
    }
};
const getters = {
    jacket_error: (state) => state.jacket_error,
    jacketErrorMessage: (state) => state.jacketErrorMessage,
    curentJacket: (state) => state.curentJacket,
    jacketSelectd: (state) => state.jacketSelectd,
    styles: (state) => state.styles,
    sides: (state) => state.sides,
    jacketDesign: (state) => state.jacketDesign,
    common_jacket: (state) => state.common_jacket,
    common_front: (state) => state.common_front,
    common_back: (state) => state.common_back,
    common_left: (state) => state.common_left,
    common_right: (state) => state.common_right,
    hoodie_jacket: (state) => state.hoodie_jacket,
    hoodie_front: (state) => state.hoodie_front,
    hoodie_back: (state) => state.hoodie_back,
    hoodie_left: (state) => state.hoodie_left,
    hoodie_right: (state) => state.hoodie_right,
    colors: (state) => state.colors,
    colorType: (state) => state.colorType,
    jacket_div: (state) => state.jacket_div,
    jacket_selected: (state) => state.jacket_selected,

    body_div: (state) => state.body_div,
    body_selected: (state) => state.body_selected,
    body_id: (state) => state.body_id,

    sleeve_div: (state) => state.sleeve_div,
    sleeve_selected: (state) => state.sleeve_selected,
    sleeve_id: (state) => state.sleeve_id,

    pocket_div: (state ) => state.pocket_div,
    pocket_selected: (state) => state.pocket_selected,
    pocket_id: (state) => state.pocket_id,

    button_div: (state ) => state.button_div,
    button_selected: (state) => state.button_selected,
    button_id: (state) => state.button_id,

    knit_div: (state ) => state.knit_div,
    knit_selected: (state) => state.knit_selected,
    solid_div: (state ) => state.solid_div,
    solid_selected: (state) => state.solid_selected,
    solid_id: (state) => state.solid_id,
    single_div: (state ) => state.single_div,
    single_selected: (state) => state.single_selected,
    single_stripe_id: (state) => state.single_stripe_id,
    double_div: (state ) => state.double_div,
    double_selected: (state) => state.double_selected,
    double_stripe_id: (state) => state.double_stripe_id,

    feather_selected : (state) => state.feather_selected,
    feather_div : (state) => state.feather_div,
    feather_stripe_id: (state) => state.feather_stripe_id,

    fonts: (state) => state.fonts,

    leftChest_div: (state ) => state.leftChest_div,
    leftChest_selected: (state) => state.leftChest_selected,
    leftChest_id: (state) => state.leftChest_id,
    leftChest: (state) => state.leftChest,
    leftChest_letters: (state) => state.leftChest_letters,
    leftChest_letters_fontfamily: (state) => state.leftChest_letters_fontfamily,
    leftChest_letters_fontfamily_id: (state) => state.leftChest_letters_fontfamily_id,
    leftChest_letters_colors_id: (state) => state.leftChest_letters_colors_id,
    leftChest_basecolor_div: (state) => state.leftChest_basecolor_div,
    leftChest_outlinecolor_div: (state) => state.leftChest_outlinecolor_div,
    leftChest_basecolor_id: (state) => state.leftChest_basecolor_id,
    leftChest_outlinecolor_id: (state) => state.leftChest_outlinecolor_id,
    leftChest_years: (state) => state.leftChest_years,
    leftChest_years_id: state => state.leftChest_years_id,
    leftChest_logos: (state) => state.leftChest_logos,
    leftChest_years_color_div: state => state.leftChest_years_color_div,
    leftChest_years_basecolor_id: state => state.leftChest_years_basecolor_id,
    leftChest_years_basecolor: state => state.leftChest_years_basecolor,
    leftChest_years_outlinecolor: state => state.leftChest_years_outlinecolor,
    leftChest_years_outlinecolor_id: state => state.leftChest_years_outlinecolor_id,
    
    rightChest_div: (state ) => state.rightChest_div,
    rightChest_selected: (state) => state.rightChest_selected,
    rightChest_id: (state) => state.rightChest_id,
    rightChest: (state) => state.rightChest,
    rightChest_letters: (state) => state.rightChest_letters,
    rightChest_letters_fontfamily: (state) => state.rightChest_letters_fontfamily,
    rightChest_letters_fontfamily_id: (state) => state.rightChest_letters_fontfamily_id,
    rightChest_name: (state) => state.rightChest_name,
    rightChest_name_fontfamily: (state) => state.rightChest_name_fontfamily,
    rightChest_name_fontfamily_id: (state) => state.rightChest_name_fontfamily_id,
    rightChest_name_basecolor_id: (state) => state.rightChest_name_basecolor_id,
    
    rightChest_letters_colors_id: (state) => state.rightChest_letters_colors_id,
    rightChest_basecolor_div: (state) => state.rightChest_basecolor_div,
    rightChest_outlinecolor_div: (state) => state.rightChest_outlinecolor_div,
    rightChest_basecolor_id: (state) => state.rightChest_basecolor_id,
    rightChest_outlinecolor_id: (state) => state.rightChest_outlinecolor_id,
    rightChest_years: (state) => state.rightChest_years,
    rightChest_years_id: state => state.rightChest_years_id,
    rightChest_logos: (state) => state.rightChest_logos,
    rightChest_years_color_div: state => state.rightChest_years_color_div,
    rightChest_years_basecolor_id: state => state.rightChest_years_basecolor_id,
    rightChest_years_basecolor: state => state.rightChest_years_basecolor,
    rightChest_years_outlinecolor: state => state.rightChest_years_outlinecolor,
    rightChest_years_outlinecolor_id: state => state.rightChest_years_outlinecolor_id,
    

    rightSleeve_div: (state ) => state.rightSleeve_div,
    rightSleeve_selected: (state) => state.rightSleeve_selected,
    rightSleeve_id: (state) => state.rightSleeve_id,
    rightSleeve: (state) => state.rightSleeve,
    rightSleeve_letters: (state) => state.rightSleeve_letters,
    rightSleeve_letters_fontfamily: (state) => state.rightSleeve_letters_fontfamily,
    rightSleeve_letters_fontfamily_id: (state) => state.rightSleeve_letters_fontfamily_id,
    rightSleeve_letters_colors_id: (state) => state.rightSleeve_letters_colors_id,
    rightSleeve_basecolor_div: (state) => state.rightSleeve_basecolor_div,
    rightSleeve_outlinecolor_div: (state) => state.rightSleeve_outlinecolor_div,
    rightSleeve_basecolor_id: (state) => state.rightSleeve_basecolor_id,
    rightSleeve_outlinecolor_id: (state) => state.rightSleeve_outlinecolor_id,
    rightSleeve_years: (state) => state.rightSleeve_years,
    rightSleeve_years_id: state => state.rightSleeve_years_id,
    rightSleeve_logos: (state) => state.rightSleeve_logos,
    rightSleeve_years_color_div: state => state.rightSleeve_years_color_div,
    rightSleeve_years_basecolor_id: state => state.rightSleeve_years_basecolor_id,
    rightSleeve_years_basecolor: state => state.rightSleeve_years_basecolor,
    rightSleeve_years_outlinecolor: state => state.rightSleeve_years_outlinecolor,
    rightSleeve_years_outlinecolor_id: state => state.rightSleeve_years_outlinecolor_id,

    leftSleeve_div: (state ) => state.leftSleeve_div,
    leftSleeve_selected: (state) => state.leftSleeve_selected,
    leftSleeve_id: (state) => state.leftSleeve_id,
    leftSleeve: (state) => state.leftSleeve,
    leftSleeve_letters: (state) => state.leftSleeve_letters,
    leftSleeve_letters_fontfamily: (state) => state.leftSleeve_letters_fontfamily,
    leftSleeve_letters_fontfamily_id: (state) => state.leftSleeve_letters_fontfamily_id,
    leftSleeve_letters_colors_id: (state) => state.leftSleeve_letters_colors_id,
    leftSleeve_basecolor_div: (state) => state.leftSleeve_basecolor_div,
    leftSleeve_outlinecolor_div: (state) => state.leftSleeve_outlinecolor_div,
    leftSleeve_basecolor_id: (state) => state.leftSleeve_basecolor_id,
    leftSleeve_outlinecolor_id: (state) => state.leftSleeve_outlinecolor_id,
    leftSleeve_years: (state) => state.leftSleeve_years,
    leftSleeve_years_id: state => state.leftSleeve_years_id,
    leftSleeve_logos: (state) => state.leftSleeve_logos,
    leftSleeve_years_color_div: state => state.leftSleeve_years_color_div,
    leftSleeve_years_basecolor_id: state => state.leftSleeve_years_basecolor_id,
    leftSleeve_years_basecolor: state => state.leftSleeve_years_basecolor,
    leftSleeve_years_outlinecolor: state => state.leftSleeve_years_outlinecolor,
    leftSleeve_years_outlinecolor_id: state => state.leftSleeve_years_outlinecolor_id,
   
    back: (state) => state.back,
    back_div: (state ) => state.back_div,
    back_selected: (state) => state.back_selected,
    backShoulder_id: (state) => state.backShoulder_id,
    backShoulder_letters: (state ) => state.backShoulder_letters,
    backShoulder_letters_fontfamily: (state ) => state.backShoulder_letters_fontfamily,
    backShoulder_letters_fontfamily_id: (state ) => state.backShoulder_letters_fontfamily_id,
    backShoulder_letters_colors_id: (state ) => state.backShoulder_letters_colors_id,
    backShoulder_letters_basecolor_div: (state ) => state.backShoulder_letters_basecolor_div,
    backShoulder_letters_basecolor: (state ) => state.backShoulder_letters_basecolor,
    backShoulder_letters_basecolor_id: (state ) => state.backShoulder_letters_basecolor_id,
    backShoulder_letters_outlinecolor_div: (state ) => state.backShoulder_letters_outlinecolor_div,
    backShoulder_letters_outlinecolor: (state ) => state.backShoulder_letters_outlinecolor,
    backShoulder_letters_outlinecolor_id: (state ) => state.backShoulder_letters_outlinecolor_id,
    backShoulder_logos: (state ) => state.backShoulder_logos,
    backShoulderWaist_letters: (state ) => state.backShoulderWaist_letters,
    backShoulderWaist_letters_fontfamily: (state ) => state.backShoulderWaist_letters_fontfamily,
    backShoulderWaist_letters_fontfamily_id: (state ) => state.backShoulderWaist_letters_fontfamily_id,
    backShoulderWaist_letters_colors_id: (state ) => state.backShoulderWaist_letters_colors_id,
    backShoulderWaist_letters_basecolor_div: (state ) => state.backShoulderWaist_letters_basecolor_div,
    backShoulderWaist_letters_basecolor: (state ) => state.backShoulderWaist_letters_basecolor,
    backShoulderWaist_letters_basecolor_id: (state ) => state.backShoulderWaist_letters_basecolor_id,
    backShoulderWaist_letters_outlinecolor_div: (state ) => state.backShoulderWaist_letters_outlinecolor_div,
    backShoulderWaist_letters_outlinecolor: (state ) => state.backShoulderWaist_letters_outlinecolor,
    backShoulderWaist_letters_outlinecolor_id: (state ) => state.backShoulderWaist_letters_outlinecolor_id,
    sizes: (state) => state.sizes,

    place_div: (state) => state.place_div,
    place_id: (state) => state.place_id,
    jacketFront: (state) => state.jacketFront,
    jacketBack: (state) => state.jacketBack,
    jacketLeft: (state) => state.jacketLeft,
    jacketRight: (state) => state.jacketRight,
    jacketDetails: (state) => {
        
        return {
           
            currentJacket: state.curentJacket,
            body_color: state.body_color,
            sleeve_color: state.sleeve_color,
            pocket_color: state.pocket_color,
            button_color: state.button_color,
            knit: {
                solid_color: state.solid_color,
                single_stripe_color: state.single_stripe_color,
                double_stripe_color: state.double_stripe_color,
                feather_stripe_color: state.feather_stripe_color
            },
            leftChest: {
                leftChest_letters: state.leftChest_letters,
                leftChest_letters_color: state.leftChest_letters_color,
                leftChest_letters_fontfamily: state.leftChest_letters_fontfamily,
                leftChest_basecolor: state.leftChest_basecolor,
                leftChest_basecolor: state.leftChest_basecolor,
                leftChest_logos: state.leftChest_logos, 
                leftChest_years: state.leftChest_years, 
                leftChest_years_basecolor: state.leftChest_years_basecolor, 
                leftChest_years_outlinecolor: state.leftChest_years_outlinecolor,    
            },
            rightChest: {
                rightChest_name: state.rightChest_name,
                rightChest_name_fontfamily: state.rightChest_name_fontfamily,
                rightChest_name_basecolor: state.rightChest_name_basecolor,
                rightChest_letters: state.rightChest_letters,
                rightChest_letters_color: state.rightChest_letters_color,
                rightChest_letters_fontfamily: state.rightChest_letters_fontfamily,
                rightChest_basecolor: state.rightChest_basecolor,
                rightChest_basecolor: state.rightChest_basecolor,
                rightChest_logos: state.rightChest_logos, 
                rightChest_years: state.rightChest_years, 
                rightChest_years_basecolor: state.rightChest_years_basecolor, 
                rightChest_years_outlinecolor: state.rightChest_years_outlinecolor,    
            },
            leftSleeve: {
                leftSleeve_letters: state.leftSleeve_letters,
                leftSleeve_letters_color: state.leftSleeve_letters_color,
                leftSleeve_letters_fontfamily: state.leftSleeve_letters_fontfamily,
                leftSleeve_basecolor: state.leftSleeve_basecolor,
                leftSleeve_basecolor: state.leftSleeve_basecolor,
                leftSleeve_logos: state.leftSleeve_logos, 
                leftSleeve_years: state.leftSleeve_years, 
                leftSleeve_years_basecolor: state.leftSleeve_years_basecolor, 
                leftSleeve_years_outlinecolor: state.leftSleeve_years_outlinecolor,    
            },
            rightSleeve: {
                rightSleeve_letters: state.rightSleeve_letters,
                rightSleeve_letters_color: state.rightSleeve_letters_color,
                rightSleeve_letters_fontfamily: state.rightSleeve_letters_fontfamily,
                rightSleeve_basecolor: state.rightSleeve_basecolor,
                rightSleeve_basecolor: state.rightSleeve_basecolor,
                rightSleeve_logos: state.rightSleeve_logos, 
                rightSleeve_years: state.rightSleeve_years, 
                rightSleeve_years_basecolor: state.rightSleeve_years_basecolor, 
                rightSleeve_years_outlinecolor: state.rightSleeve_years_outlinecolor,    
            },
            back_customization: {
                backShoulder_letters: state.backShoulderWaist_letters,
                backShoulder_letters_basecolor: state.backShoulder_letters_basecolor,
                backShoulder_letters_outlinecolor: state.backShoulder_letters_outlinecolor,
                backShoulder_letters_fontfamily: state.backShoulder_letters_fontfamily,
                backShoulder_logos: state.backShoulder_logos,
                backShoulderWaist_letters: state.backShoulderWaist_letters,
                backShoulderWaist_letters_fontfamily: state.backShoulderWaist_letters_fontfamily,
                backShoulderWaist_letters_fontfamily: state.backShoulderWaist_letters_fontfamily,
                backShoulderWaist_letters_basecolor: state.backShoulderWaist_letters_basecolor,
                backShoulderWaist_letters_outlinecolor: state.backShoulderWaist_letters_outlinecolor,
            }

        }
    }
};

export default {
    state, mutations,actions,getters
}